// extracted by mini-css-extract-plugin
export default {"box":"box__Ls8dM","btn":"btn__JZ4A0"};